import { RoleModel } from '../models/role.model';

export class CreateRole{
    static readonly type= '[RoleModel] Create';

    constructor(public payload: RoleModel){ }
}

export class GetRoles{
    static readonly type= '[RoleModel] Get';
}

// export class DeleteRoles{
//     static readonly type= '[RoleModel] Delete';

//     constructor(public id:number){}
// }

// export class UpdateRoles{
//     static readonly type= '[RoleModel] Update';

//     constructor(public payload: RoleModel,public id: number){}
// }

export class SetSelectedRole{
    static readonly type= '[RoleModel] Set';

    constructor(public payload: RoleModel){}
}